import React from "react";
import PropTypes from "prop-types";
import { TableRow } from "@mui/material";

import TextInput from "../../../ui/TextInput";
import TableItem from "../../../ui/TableItem";
import { INTX_TYPE_TO_LABEL } from "../../../constants/intxConstants";

export default function CMFsTableRow({
  errors,
  formData,
  isFirstRow,
  register,
  rowName,
  rowLabel,
  type,
}) {
  return (
    <TableRow>
      {isFirstRow && (
        <TableItem size="small" rowSpan={2}>
          {INTX_TYPE_TO_LABEL[type]}
        </TableItem>
      )}
      <TableItem>{rowLabel}</TableItem>
      <TableItem size="small" sx={{ textAlign: "center" }}>
        <TextInput
          register={register}
          name={`${type}.${rowName}.overrideValue`}
          errors={errors}
          type="number"
          min={0.01}
          max={3}
          size="small"
          step="0.01"
          defaultValue={formData?.[type]?.[rowName]?.overrideValue}
        />
      </TableItem>
      <TableItem size="small" sx={{ textAlign: "center" }}>
        <TextInput
          register={register}
          name={`${type}.${rowName}.notes`}
          errors={errors}
          type="text"
          size="small"
          defaultValue={formData?.[type]?.[rowName]?.notes}
        />
      </TableItem>
    </TableRow>
  );
}

CMFsTableRow.propTypes = {
  errors: PropTypes.object.isRequired,
  formData: PropTypes.object.isRequired,
  register: PropTypes.func.isRequired,
};
